import { render, staticRenderFns } from "./AlertDialogHeader.vue?vue&type=template&id=145704b4&"
import script from "./AlertDialogHeader.vue?vue&type=script&lang=js&"
export * from "./AlertDialogHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports